// Import 3rd party libraries
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Scene from "../apply/Scene";

gsap.registerPlugin(ScrollTrigger);

export default function() {
    const matches = {
        canAnimate: "(min-width: 992px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }

    let mm = gsap.matchMedia();

    mm.add(matches, (context) => {
        if(context.conditions.canAnimate) {
            let scene = new Scene();

            ScrollTrigger.create({
                trigger: "#apply",
                start: "top bottom",
                end: "bottom top",
                onEnter: () => {
                    scene.start();
                },
                onEnterBack: () => {
                    scene.start();
                },
                onLeave: () => {
                    scene.end();
                },
                onLeaveBack: () => {
                    scene.end();
                }
            });
        }
    });
}